import {
  Grid,
  Image,
  Show,
  Spacer,
  Heading,
  Center,
  Box,
} from "@chakra-ui/react";

import { hiddenSponsorType, competitionMainSponsorType, competitionObstacleSponsorType } from "./modify_sponsors";
import { Sponsor } from "../Api/dto/Sponsors";
import { useMemo } from "react";




export function MainSponsors(props: { sponsorList: Sponsor[] }) {
  return (
    <>
      <Show above="sm">
        <Grid templateColumns="repeat(2, 1fr)" gap={5} margin={"20px"}>
          {props.sponsorList.map((sponsor) => (
            <SponsorComponent
              key={`main-${sponsor.id}`}
              imageName={sponsor.imageName}
              homepage={sponsor.url}
            />
          ))}
        </Grid>
      </Show>
      <Show below="sm">
        <Grid
          templateColumns="repeat(1, 1fr)"
          gap={10}
          margin={"20px"}
          marginBottom={"100px"}
        >
          {props.sponsorList.map((sponsor) => (
            <SponsorComponent
              key={`main-${sponsor.id}`}
              imageName={sponsor.imageName}
              homepage={sponsor.url}
            />
          ))}
        </Grid>
      </Show>
    </>
  );
}
export function HinderbanaSponsors(props: { sponsorList: Sponsor[] }) {
  return (
    <>
      <Show above="sm">
        <Grid
          alignContent={"center"}
          templateColumns="repeat(4, 1fr)"
          gap={8}
          margin={"20px"}
        >
          {props.sponsorList.map((sponsor) => (
            <SponsorComponent
              key={`hb-${sponsor.id}`}
              imageName={sponsor.imageName}
              homepage={sponsor.url}
            />
          ))}
        </Grid>
      </Show>
      <Show below="sm">
        <Grid
          alignContent={"center"}
          templateColumns="repeat(2, 1fr)"
          gap={8}
          margin={"20px"}
        >
          {props.sponsorList.map((sponsor) => (
            <SponsorComponent
              key={`hb-${sponsor.id}`}
              imageName={sponsor.imageName}
              homepage={sponsor.url}
            />
          ))}
        </Grid>
      </Show>
    </>
  );
}

export function OtherSponsors(props: { sponsorList: Sponsor[] }) {
  return (
    <>
      <Show above="sm">
        <Grid
          alignContent={"center"}
          templateColumns="repeat(4, 1fr)"
          gap={8}
          margin={"20px"}
        >
          {props.sponsorList.map((sponsor) => (
            <SponsorComponent
              key={`o-${sponsor.id}`}
              imageName={sponsor.imageName}
              homepage={sponsor.url}
            />
          ))}
        </Grid>
      </Show>
      <Show below="sm">
        <Grid
          templateColumns="repeat(2, 1fr)"
          gap={8}
          margin={"20px"}
          alignContent={"center"}
        >
          {props.sponsorList.map((sponsor) => (
            <SponsorComponent
              key={`o-${sponsor.id}`}
              imageName={sponsor.imageName}
              homepage={sponsor.url}
            />
          ))}
        </Grid>
      </Show>
    </>
  );
}

function shuffleArray(array: Array<any>) {
  const copy = [...array];
  for (var i = 0; i < copy.length; i++) {
    var j = Math.min(i, Math.floor(Math.random() * (i + 1)));
    var temp = copy[i];
    copy[i] = copy[j];
    copy[j] = temp;
  }
  return copy;
}





export const Sponsors = (props: {
  sponsors: Array<Sponsor>;
  mainHeading?: string;
  otherHeading?: string;
  hinderHeading?: string;
}) => {
  const shuffledSponsors = useMemo(() => shuffleArray(props.sponsors), [props.sponsors]);

  return (
    <>
      <Heading marginBottom={"30px"} size={"2xl"} textAlign="center">
        {props.mainHeading}
      </Heading>
      <MainSponsors sponsorList={shuffledSponsors.filter(s => s.context === competitionMainSponsorType)} />
      <Spacer h={"100px"} hidden={props.otherHeading == null} />
      <Heading size={"xl"} textAlign="center">
        {props.otherHeading}
      </Heading>
      <OtherSponsors sponsorList={shuffledSponsors.filter(s => ![competitionMainSponsorType, hiddenSponsorType, competitionObstacleSponsorType].includes(s.context))} />
      <Spacer h={"100px"} hidden={props.hinderHeading == null} />
      <Heading size={"xl"} textAlign="center">
        {props.hinderHeading}
      </Heading>
      <HinderbanaSponsors sponsorList={shuffledSponsors.filter(s => s.context === competitionObstacleSponsorType)} />
    </>
  );
};

function SponsorComponent(props: { homepage: string | undefined; imageName: string }) {
  const imageUrl = `/media/images/${props.imageName}`;
  return props.homepage != undefined && props.homepage != "" ? (
    <Center>
      <Box
        _hover={{
          transform: "scale(1.3)",
          transition: "transform 0.3s ease-in-out",
        }}
      >
        <a href={props.homepage} target="_blank" rel="noopener noreferrer">
          <Image src={imageUrl} alt={"SponsorLogo"} />
        </a>
      </Box>
    </Center>
  ) : (
    <Center>
      <Image src={imageUrl} alt="SponsorLogo" />
    </Center>
  );
}
